const initNavigation = () => {
	const $trigger = $('.nav-trigger');

	$trigger.on('click', function(event) {
		const $mobileNavigation = $('.header__navigation');

		$mobileNavigation.toggleClass('is-open');

		event.preventDefault();
	});
}

initNavigation();
